import React from 'react';
import { Grid } from '@mui/material';

type Props = {}

const PayPage = (props: Props) => {
    return (
        <>
            <Grid container spacing={2} sx={{ mt: 5, p: 20 }}>
                
            </Grid>
        </>
    )
}

export default PayPage